module.exports = __webpack_public_path__ + "static/media/1POLICY14.1d10f8b3.jpg";